import type { ReactNode } from "react";
import { cn } from "../lib/utils";
import { Tooltip } from "../ui/Tooltip";

export const BOND_FORM_HEADER = "Bond Form";
export const BOND_FORM_TOOLTIP = "Please select a bond form from the library, or upload your own";
export const BOND_FORM_UPLOAD_ONLY_TOOLTIP = "Please upload a bond form";

export type BondFormSectionHeaderProps = {
	/** Must be unique per rendered instance — it backs the tooltip anchor's DOM id. */
	tooltipId: string;
	label?: ReactNode;
	tooltipContent?: string;
	className?: string;
	tooltipClassName?: string;
	tooltipMaxWidth?: number;
	condensed?: boolean;
	showTooltip?: boolean;
	testId?: string;
};

export const BondFormSectionHeader = ({
	tooltipId,
	label = BOND_FORM_HEADER,
	tooltipContent = BOND_FORM_TOOLTIP,
	className,
	tooltipClassName,
	tooltipMaxWidth,
	condensed = true,
	showTooltip = true,
	testId = "bond-form-section-header",
}: BondFormSectionHeaderProps) => (
	<span className={cn("flex items-center gap-[8px]", className)} data-testid={testId}>
		{label}
		{showTooltip && (
			<Tooltip
				id={tooltipId}
				content={tooltipContent}
				className={tooltipClassName}
				maxWidth={tooltipMaxWidth}
				condensed={condensed}
				ariaLabel="Bond form guidance"
			/>
		)}
	</span>
);
